var graphemeSegmenter = new Intl.Segmenter();
/**
* returns the first (non-sigil) character of 'name',
* converted to uppercase
* @param {string} name
* @return {string} the first letter
*/
function getInitialLetter(name) {
	if (name.length < 1) return "";
	const initial = name[0];
	if ([
		"@",
		"#",
		"+"
	].includes(initial)) name = name.substring(1);
	const result = graphemeSegmenter.segment(name)[Symbol.iterator]().next();
	return result.done ? "" : result.value.segment;
}
//#endregion
export { getInitialLetter };

//# sourceMappingURL=string.js.map